<cap-list-loader [listLoader]="listLoader">
  <div class="cap-list-loader-title">
    <ng-content select="[name=title]"></ng-content>
  </div>
  <div class="cap-list-loader-content">
    <table class="cap-table-search">
      <thead>
        <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
      </thead>
      <tbody>
        <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
      </tbody>
    </table>
  </div>
</cap-list-loader>
<ng-template #tableHeaders>
  <tr>
    <th class="noselect" style="cursor: pointer">
      <cap-column-header [columnName]="'EGID_EWID'" [sortModel]="tableSortModel.columns.get('ewid')"></cap-column-header>
    </th>
    <th class="noselect" style="cursor: pointer">
      <cap-column-header [columnName]="'AdresseEingang'" [sortModel]="tableSortModel.columns.get('adresse')"></cap-column-header>
    </th>
    <th class="noselect" style="cursor: pointer">
      <cap-column-header [columnName]="'Status'" [sortModel]="tableSortModel.columns.get('wohnungsstatus')"></cap-column-header>
    </th>
    <th class="noselect" style="cursor: pointer">
      <cap-column-header [columnName]="'AdminNr'" [sortModel]="tableSortModel.columns.get('administrativeNummer')"></cap-column-header>
    </th>
    <th class="noselect" style="cursor: pointer">
      <cap-column-header [columnName]="'Stockwerk'" [sortModel]="tableSortModel.columns.get('stockwerk')"></cap-column-header>
    </th>
    <th class="noselect" style="cursor: pointer">
      <cap-column-header [columnName]="'LageStockwerk'" [sortModel]="tableSortModel.columns.get('lageAufStockwerk')"></cap-column-header>
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (eingangAdresse of listLoader?.items; track eingangAdresse) {
    <tr>
      <td>
        <cap-link [params]="[eingangAdresse.egid.value, eingangAdresse.ewid.value]" [target]="navTargets.NAV_GWR_WOHNUNG">
          {{ eingangAdresse.egid.value }}/{{ eingangAdresse.ewid.value }}
        </cap-link>
      </td>
      <td>
        <cap-link [params]="[eingangAdresse.egid.value, eingangAdresse.ewid.value]" [target]="navTargets.NAV_GWR_WOHNUNG">
          {{ eingangAdresse.adresse | kompaktGwrGebaeudeeingangsadresse }}
        </cap-link>
      </td>
      <td>
        <cap-link [params]="[eingangAdresse.egid.value, eingangAdresse.ewid.value]" [target]="navTargets.NAV_GWR_WOHNUNG">
          {{ eingangAdresse.wohnungsstatus | translate }}
        </cap-link>
      </td>
      <td>
        <cap-link [params]="[eingangAdresse.egid.value, eingangAdresse.ewid.value]" [target]="navTargets.NAV_GWR_WOHNUNG">
          {{ eingangAdresse.administrativeNummer }}
        </cap-link>
      </td>
      @if (eingangAdresse.stockwerk.stockwerkNummer) {
        <td>
          <cap-link [params]="[eingangAdresse.egid.value, eingangAdresse.ewid.value]" [target]="navTargets.NAV_GWR_WOHNUNG">
            {{ eingangAdresse.stockwerk.stockwerkNummer }}
            . {{ eingangAdresse.stockwerk.stockwerkBezeichnung | translate }}
          </cap-link>
        </td>
      } @else {
        <td>
          <cap-link [params]="[eingangAdresse.egid.value, eingangAdresse.ewid.value]" [target]="navTargets.NAV_GWR_WOHNUNG">
            {{ eingangAdresse.stockwerk.stockwerkBezeichnung | translate }}
          </cap-link>
        </td>
      }
      <td>
        <cap-link [params]="[eingangAdresse.egid.value, eingangAdresse.ewid.value]" [target]="navTargets.NAV_GWR_WOHNUNG">
          {{ eingangAdresse.lageAufStockwerk | translate }}
        </cap-link>
      </td>
    </tr>
  }
</ng-template>
